import Api from './Api'

export default {
  getUnsoldObjects (queryParams) {
    return Api().get('/oppgave/unsold-objects.json', {
      params: queryParams
    })
  },

  sendUnsoldObjectEmail (taskId, data) {
    return Api().post('/oppgave/' + taskId + '/unsold-object-email.json', data)
  },

  save (taskId, data) {
    return Api().put('/oppgave/' + taskId + '.json', data)
  },

  addComment (taskId, data) {
    return Api().post('/oppgave/' + taskId + '/comment.json', data)
  }
}



// WEBPACK FOOTER //
// ./src/services/OppgaveService.js